module.exports = __webpack_public_path__ + "img/personas-en.9dc6cb09.png";